export default "__VITE_ASSET__DCh_MyWO__"